__turbopack_context__.v({
  "adornment": "AdVlmG_adornment",
  "chevron": "AdVlmG_chevron",
  "hasValue": "AdVlmG_hasValue",
  "itemIcon": "AdVlmG_itemIcon",
  "label": "AdVlmG_label",
  "menu": "AdVlmG_menu",
  "menuItem": "AdVlmG_menuItem",
  "select": "AdVlmG_select",
  "small": "AdVlmG_small",
  "solid": "AdVlmG_solid",
});
